import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.image-marquee__splide' ).length ) {
        $( '.image-marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            perPage: 1,
            gap: '2rem',
            autoWidth: true,
            arrows: true,
            focus: 'center',
            pagination: false,
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-marquee', COMPONENT );
} )( app );
